import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  StatusBar, SafeAreaView, StyleSheet, View, ScrollView, Text,
} from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import Header from '../components/Header';
import WorkoutTypeCard from '../components/WorkoutTypeCard';
import WorkoutCard from '../components/WorkoutCard';
import trainingActions from '../actions/trainingActions';
import StatusTypes from '../store/types';
import APMStyles from '../styles';

const enduranceImg = require('../assets/images/workout-types/endurance.jpeg');
const painReliefImg = require('../assets/images/workout-types/painrelief.jpeg');
const strengthImg = require('../assets/images/workout-types/strength.jpeg');
const flexibilityImg = require('../assets/images/workout-types/flexibility.jpeg');

function Home({ navigation }) {
  const [workoutType, setWorkoutType] = useState('');
  const status = useSelector((state) => state.training.status);
  const workouts = useSelector((state) => state.training.workouts);
  const dispatch = useDispatch();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (status === StatusTypes.getWorkoutsPending) {
      console.log('loading exercises');
    } else if (status === StatusTypes.getWorkoutSuccess) {
      navigation.navigate('Workout');
    } else if (status === StatusTypes.getWorkoutFail) {
      console.log('error retrieving exercises');
    }
  }, [status]);

  function selectWorkout(type) {
    setWorkoutType(type);
    dispatch(trainingActions.getWorkouts(type));
  }

  useEffect(() => {
    if (isFocused) {
      selectWorkout('endurance');
    }
  }, [isFocused]);

  console.log(status);
  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.header}>
        <StatusBar barStyle="dark-content" />
        <Header style={styles.header} navigation={navigation} />
      </SafeAreaView>

      <View style={styles.banner}>
        <Text style={styles.title}>SELECT WORKOUT</Text>
      </View>

      <View style={styles.content}>
        <View style={styles.workoutTypeContainer}>
          <ScrollView horizontal contentContainerStyle={styles.scrollViewContainer}>
            <WorkoutTypeCard
              backgroundImg={enduranceImg}
              title="Endurance"
              selected={workoutType === 'endurance'}
              onPress={() => selectWorkout('endurance')}
            />
            <WorkoutTypeCard
              backgroundImg={painReliefImg}
              title="Pain Relief"
              selected={workoutType === 'painrelief'}
              onPress={() => selectWorkout('painrelief')}
            />
            <WorkoutTypeCard
              backgroundImg={strengthImg}
              title="Strength"
              selected={workoutType === 'strength'}
              onPress={() => selectWorkout('strength')}
            />
            <WorkoutTypeCard
              backgroundImg={flexibilityImg}
              title="Flexibility"
              selected={workoutType === 'flexibility'}
              onPress={() => selectWorkout('flexibility')}
            />
          </ScrollView>
        </View>

        <ScrollView contentContainerStyle={styles.workoutContainer}>
          {status === StatusTypes.getWorkoutsPending
            && <Text style={styles.status}>loading...</Text>}
          {status === StatusTypes.getWorkoutsFail
            && <Text style={styles.status}>error</Text>}
          {status === StatusTypes.getWorkoutsSuccess && workouts
            && workouts.map((workout) => (
              <WorkoutCard
                key={workout.name}
                title={workout.name}
                description={workout.description}
                time={workout.time}
                backgroundImg={workout.img}
                onPress={() => dispatch(trainingActions.getWorkout(workout.name))}
              />
            ))}
        </ScrollView>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  banner: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
    letterSpacing: 6,
  },
  status: {
    color: APMStyles.colors.text,
  },
  content: {
    flex: 10,
  },
  scrollViewContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingBottom: 20,
  },
  workoutTypeContainer: {
    paddingBottom: 20,
  },
  workoutContainer: {
    flex: 1,
    alignItems: 'center',
  },
});

export default Home;
